const cache = {};

/*
 * parseMeta is useful for grabbing data out of the head
 * passed up from the server.
 *
 * parseMeta will _first_ check to see if the data is cached and
 * return that value first.
 *
 * while it may be tempting to store base64 tags into the head,
 * there are some serious issues with parsing utf8 strings.
 */
export function parseMeta(tagName) {
  if (process.env.NODE_ENV === 'production') {
    if (cache[tagName]) { return cache[tagName]; }
  }

  try {
    const tag = document.querySelector(`meta[name=${tagName}]`);
    if (!tag || !tag.content) { return; }

    const parsed = JSON.parse(tag.content);
    cache[tagName] = parsed;

    return parsed;
  } catch (e) {
    console.error(`could not parse ${name}`, e);
  }

  return null;
}



// WEBPACK FOOTER //
// ./javascripts/components/parse_meta.js